import { render, staticRenderFns } from "./ConvoTags.vue?vue&type=template&id=f9f36e96&"
import script from "./ConvoTags.vue?vue&type=script&lang=js&"
export * from "./ConvoTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports